<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel header="{{'label.search' | translate }}" [toggleable]="true" [collapsed]="panelCollapsed"
      expandIcon="pi pi-angle-double-up" collapseIcon="pi pi-angle-double-down">
      <div class="card" #contentElement pBPaaSFocusTrap>
        <!-- Row 1: Application Type, Request Date, Request OU, Inv OU -->
        <div class="grid p-fluid">
          <!-- Application Type -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('applicationType')" class="bpaas-required">Application Type</label>
            <p-dropdown [options]="appTypeOptions" formControlName="applicationType"
              optionLabel="label" optionValue="value" [showClear]="true"
              placeholder="{{ 'option.please-select' | translate }}" appendTo="body"
              [inputId]="parseToId('applicationType')">
            </p-dropdown>
            <div *ngIf="formControlInvalid('applicationType')">
              <small class="p-error" *ngIf="formControl('applicationType').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <!-- Request Date -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('requestDate')" class="bpaas-required">Request Date</label>
            <p-calendar formControlName="requestDate" [inputId]="parseToId('requestDate')"
              dateFormat="yy/mm/dd" [showIcon]="true" appendTo="body" placeholder="YYYY/MM/DD">
            </p-calendar>
            <div *ngIf="formControlInvalid('requestDate')">
              <small class="p-error" *ngIf="formControl('requestDate').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <!-- Request OU -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('reqOu')" class="bpaas-required">Request OU</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="reqOuSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchReqOuSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
              formControlName="reqOu" [inputId]="parseToId('reqOu')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('reqOu')">
              <small class="p-error" *ngIf="formControl('reqOu').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <!-- Inv OU -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('invOu')" class="bpaas-required">Inv OU</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="invOuSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchInvOuSuggestions($event)"
              (onClear)="onInvOuClear()" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="onInvOuChange()" dataKey="value" appendTo="body"
              formControlName="invOu" [inputId]="parseToId('invOu')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('invOu')">
              <small class="p-error" *ngIf="formControl('invOu').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
        </div>
        <!-- Row 2: CTMR, Item, Item Desc -->
        <div class="grid p-fluid">
          <!-- CTMR -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('ctmr')" class="bpaas-required">Cust</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="ctmrSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchCtmrSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
              formControlName="ctmr" [inputId]="parseToId('ctmr')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('ctmr')">
              <small class="p-error" *ngIf="formControl('ctmr').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <!-- Item Number -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('itemNumber')" class="bpaas-required">Item</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="itemSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              placeholder="Item Number"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchItemSuggestions($event)"
              (onClear)="onItemClear()" (onFocus)="autoCompleteFocus($event)" (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)" (onSelect)="onItemSelect($event)" dataKey="value" appendTo="body"
              formControlName="itemNumber" [inputId]="parseToId('itemNumber')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('itemNumber')">
              <small class="p-error" *ngIf="formControl('itemNumber').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <!-- Item Desc -->
          <div class="col-12 md:col-6 lg:col-6">
            <label [for]="parseToId('itemDesc')">Item Desc</label>
            <input type="text" pInputText formControlName="itemDesc" [id]="parseToId('itemDesc')" readonly />
          </div>
        </div>
        <!-- Row 3: Order Number, INV Org, End Customer, Project Name -->
        <div class="grid p-fluid">
          <!-- Order Number -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('orderNumber')">Order Number</label>
            <input type="text" pInputText formControlName="orderNumber" [id]="parseToId('orderNumber')" />
          </div>
          <!-- INV Org -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('invOrg')">Inv Org</label>
            <div class="lookup-input-wrap">
              <p-dropdown *ngIf="langChangeVisible" [options]="invOrgSuggestions" formControlName="invOrg"
                optionLabel="label" optionValue="value" [showClear]="true"
                placeholder="{{ 'option.please-select' | translate }}" appendTo="body"
                (onFocus)="loadInvOrgSuggestions()" [inputId]="parseToId('invOrg')">
              </p-dropdown>
            </div>
          </div>
          <!-- End Customer -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('endCustomer')">End Customer</label>
            <div class="lookup-input-wrap">
              <p-dropdown *ngIf="langChangeVisible" [options]="endCustomerSuggestions" formControlName="endCustomer"
                [showClear]="true" placeholder="{{ 'option.please-select' | translate }}" appendTo="body"
                (onFocus)="loadEndCustomerSuggestions()" [inputId]="parseToId('endCustomer')">
              </p-dropdown>
            </div>
          </div>
          <!-- Project Name -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('projectName')">Project Name</label>
            <input type="text" pInputText formControlName="projectName" [id]="parseToId('projectName')" />
          </div>
        </div>
        <div class="grid p-fluid justify-content-end bpaas-button-row">
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.reset' | translate }}" class="p-button-outlined mr-2"
              (click)="searchReset();onItemClear();" [id]="parseToId('btnReset')"></button>
          </div>
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.query' | translate }}" (click)="query()"
              [id]="parseToId('btnQuery')"></button>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>
<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <!-- QueryId -->
    <span *ngIf="queryId">{{ 'field.query-id' | translate }} : {{queryId}}</span>

    <p-table #tableComponent [value]="detailDatas" styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped"
      [selectionMode]="tableSelectionMode" [(selection)]="rowSelectedDatas" [dataKey]="rowDataKeyName"
      [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'table.paginator' | translate: {'first': '{first}', 'last': '{last}', 'totalRecords': '{totalRecords}' } }}"
      [rowsPerPageOptions]="[10, 20, 50]" [paginatorDropdownAppendTo]="'body'" scrollHeight="75vh" [scrollable]="true"
      [resizableColumns]="true" columnResizeMode="expand" [columns]="selectedColumns"
      [detailInViewStatus]="detailInViewStatus()" (onStateSave)="onDetailTableStateSave($event)"
      (onFilter)="onDetailTableFilter($event)" (onColResize)="onColResize($event)">
      <ng-template pTemplate="header" let-columns>
        <tr id="bpaas-table-header">
          <th *ngFor="let column of columns" [pSortableColumn]="column.sortable ? column.field : ''"
            [pSortableColumnDisabled]="column.sortable ? false : true" pResizableColumn>
            <label>{{ column.header | translate }}</label>
            <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [id]="parseToId('rowData-' + rowIndex)">
          <td *ngFor="let column of tableColumns" [class.bpaas-align-right]="column.numberField || column.alignRight"
            [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
            <ng-container *ngIf="column.numberField">
              {{ rowData[column.field] | dynamicDecimal }}
            </ng-container>
            <ng-container *ngIf="!column.numberField">
              {{ rowData[column.field] }}
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="tableColumns.length">
            {{ 'table.no-records-found' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>
